<template>
  <div class="vl-parent">
        <loading v-model:active="isLoading"
                 :can-cancel="true"
                 :on-cancel="onCancel"
                 :is-full-page="fullPage"/>
  </div>
  <div class="container mb-0 pt-0 mt-60">
        <div class="section-content">
          <div class="row mt-10">
            <form class="fed_search" @submit.prevent="searchfederation()">
              <div class="form-group col-md-10">
                <label for="">Federation Information</label>
                <input type="text" class="form-control" v-model="federation" @input="searchInput"   placeholder="Federation Name">
               <div class="productlist" v-if="federationok" ref="suggestionsList">
                <ul>
                 <li @click="selectfederation(federation)" v-for="federation in this.federationlist">{{federation.FederationName}}</li>
                 </ul>
               </div>
              </div>
              <div class="form-group col-md-2">
                <button type="submit" class="fed_search_btn"><i class="fa fa-search"></i> Search</button>
              </div>
            </form>
          </div>
         </div>
       </div>

      <h3 style="background:#007bff; padding: 10px; line-height: 42px; text-align: center; color: #fff; width:74%; margin:0 auto;">{{this.federationname}}</h3>
      <div class="container mb-0 pt-0 mt-60">
        <div class="section-content">
          <div class="row mt-10">
            <div class="table-responsive tbox" style="border:3px solid rgb(58, 63, 81);margin:10px 0px;padding:10px;"> 
              <h3 style="text-align:center;background:#3a3f51;color:white;padding:10px 0px;">Federation Registration Information </h3>
              <table class="table table-bordered" style="background:#3a3f51;color:white"> 
                <thead> 
                  <tr> 
                    <th>Registration Number</th> 
                    <th>Registration Received from (DSS/DYD /DC)*</th> 
                    <th>If applied name of the organization (DSS/DYD /DC/DWA)*</th> 
                    <th>If Dont is applied for registration Yes No*</th> 
                    <th>Date of application deposited</th> 
                    <th>Present status</th> 
                    <th v-if="this.edit">Action</th>
                  </tr> 
                </thead> 
                <tbody> 
                  <tr> 
                    <th scope="row">{{registrationinformation.RegistrationNumber}}</th> 
                    <td>{{registrationinformation.RegistrationReceivedfrom}}</td> 
                    <td>{{registrationinformation.If_applied_name_of_the_organization_DSSDYD_DCDWA  }}</td>
                    <td>{{registrationinformation.If_Dont_is_applied_for_registration_YesNo}}</td> 
                    <td>{{registrationinformation.Date_of_application_deposited}}</td>
                    <td>{{registrationinformation.Present_status}}</td> 
                    <td v-if="this.edit"><a style="cursor:pointer;" @click="registrationifnormation(registrationinformation)"><i class="fa fa-pencil"></i></a></td>
                  </tr> 
                </tbody> 
              </table> 
            </div>
            <div class="table-responsive tbox" style="border:3px solid rgb(58, 63, 81);margin:10px 0px;padding:10px;">   
              <h3 style="text-align:center;background:#3a3f51;color:white;padding:10px 0px;">Information on Organizational Structure </h3>
              <h4 style="text-align:center;border-bottom: 1px solid; padding-bottom: 5px;padding-top:10px">Federation Group Information</h4>
              <table class="table table-bordered" style="background:#3a3f51;color:white"> 
                <thead> 
                  <tr> 
                    <th>Male Group</th> 
                    <th>Female Group</th> 
                    <th>Total</th>  
                    <th v-if="this.edit">Action</th>                 
                  </tr> 
                </thead> 
                <tbody> 
                  <tr> 
                    <th scope="row">{{federationgroupinformation.Male_Group}}</th> 
                    <td>{{federationgroupinformation.Female_Group}}</td> 
                    <td>{{federationgroupinformation.Total}}</td> 

                    <td v-if="this.edit"><a style="cursor:pointer;" @click="federationgroupinformationupdate(federationgroupinformation)" ><i class="fa fa-pencil"></i></a></td>
                  </tr> 
                </tbody> 
              </table>
              <h4 style="text-align:center;border-bottom: 1px solid; padding-bottom: 5px;padding-top:10px">Federation General Member</h4>
              <table class="table table-bordered" style="background:#3a3f51;color:white"> 
                <thead> 
                  <tr> 
                    <th>Boy</th> 
                    <th>Gril</th> 
                    <th>Total</th>       
                    <th>PWD Member</th>       
                    <th>Indigenous People</th>
                    <th>Excluded Members</th> 
                    <th v-if="this.edit">Action</th>                 
                  </tr> 
                </thead> 
                <tbody> 
                  <tr> 
                    <th scope="row">{{federationgeneralmember.Male}}</th> 
                    <td>{{federationgeneralmember.Female}}</td> 
                    <td>{{federationgeneralmember.Total}}</td> 
                    <td>{{federationgeneralmember.PWD_Member}}</td> 
                    <td>{{federationgeneralmember.Indigenous_People}}</td>  
                    <td>{{federationgeneralmember.Excluded_Members}}</td>  
                    <td v-if="this.edit"><a style="cursor:pointer;" @click="federationgeneralmemberupdate(federationgeneralmember)"><i class="fa fa-pencil"></i></a></td>
                  </tr> 
                </tbody> 
              </table> 
            </div>
            <div class="table-responsive tbox" style="border:3px solid rgb(58, 63, 81);margin:10px 0px;padding:10px;"> 
              <h3 style="text-align:center;background:#3a3f51;color:white;padding:10px 0px;">Information on Federation Different Committee and Wings</h3>
              <h4 style="text-align: center;border-bottom: 1px solid; padding-bottom: 5px;padding-top:10px">General Committee Member</h4>
              <table class="table table-bordered" style="background:#3a3f51;color:white"> 
                <thead> 
                  
                  <tr> 
                    <th>Male</th> 
                    <th>Female</th> 
                    <th>Total</th> 
                    <th v-if="this.edit">Action</th>
                  </tr> 
                </thead> 
                <tbody> 
                  <tr> 
                    <th scope="row">{{generalcommitteemember.Male}}</th> 
                    <td>{{generalcommitteemember.Female}}</td> 
                    <td>{{generalcommitteemember.Total}}</td>
                    <td v-if="this.edit"><a style="cursor:pointer;" @click="generalcommitteememberupdate(generalcommitteemember)"><i class="fa fa-pencil"></i></a></td>   
                  </tr> 
                </tbody> 
              </table> 
              <h4 style="text-align: center;border-bottom: 1px solid; padding-bottom: 5px;padding-top:10px">Executive Committee Member</h4>
              <table class="table table-bordered" style="background:#3a3f51;color:white"> 
                <thead> 
                  
                  <tr> 
                    <th>Male</th> 
                    <th>Female</th> 
                    <th>Total</th> 
                    <th v-if="this.edit">Action</th>
                  </tr> 
                </thead> 
                <tbody> 
                  <tr> 
                    <th scope="row">{{executivecommitteemember.Male}}</th> 
                    <td>{{executivecommitteemember.Female}}</td> 
                    <td>{{executivecommitteemember.Total}}</td> 
                    <td v-if="this.edit"><a style="cursor:pointer;" @click="executivecommitteememberupdate(executivecommitteemember)"><i class="fa fa-pencil"></i></a></td>
                  </tr> 
                </tbody> 
              </table> 
            </div> 
          </div>
        </div>
     </div>
     
     <transition name="slide-fade">
      <div class="modal-mask2" v-if="show2">
        <div class="modal-wrapper2">
          <div class="modal-container2">
            <div class="modal-header">
              <h4 style="text-align:right;cursor:pointer;" @click="show2 = false"><i class="fa fa-times-circle"></i></h4>
              <slot name="header">
                 Edit Federation Registration Information
              </slot>
            </div>

            <div class="modal-body">
              <div class="wrappermodel">
              <div class="lefside">
                <span>Registration Number</span>
                 <input type="text" id="recivedamount" v-model="RegistrationNumber"  class="form-control">
                 <span>Registration Received from (DSS/DYD /DC)*</span>
                  <input type="text" v-model="RegistrationReceivedfrom"   class="form-control">
                  <span >If Don't, is applied for registration? (Yes/No) </span>
                  <input type="text"   class="form-control" v-model="If_Dont_is_applied_for_registration_YesNo">
              </div>
              <div class="rightside">
                  <span >If applied name of the organization (DSS/DYD /DC/DWA)*</span>
                  <input type="text"   class="form-control" v-model="If_applied_name_of_the_organization_DSSDYD_DCDWA">
                  <span >Date of application deposited</span>
                  <input type="text"   class="form-control" v-model="Date_of_application_deposited">
                  <span >Present status</span>
                  <input type="text"   class="form-control" v-model="Present_status">
              </div>
            </div>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="updateregistration()">
                  Update Registration Information
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
     </transition> 



    <transition name="slide-fade">
      <div class="modal-mask3" v-if="show3">
        <div class="modal-wrapper3">
          <div class="modal-container3">
            <div class="modal-header">
              <h4 style="text-align:right;cursor:pointer;" @click="show3 = false"><i class="fa fa-times-circle"></i></h4>
              <slot name="header">
                 Edit Federation Group Information
              </slot>
            </div>

            <div class="modal-body">
              <div class="wrappermodel">
              <div class="lefside">
                <span>Male Group</span>
                 <input type="text" id="recivedamount" v-model="groupinformationMale_Group"  class="form-control">
                 <span>Female Group</span>
                  <input type="text" v-model="groupinformationFemale_Group"   class="form-control">
                  <span >Total</span>
                  <input type="text"   class="form-control" v-model="groupinformationTotal">
              </div>
            </div>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="updategroupinformation()">
                  Update Federation Group Information
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
     </transition>  

     <transition name="slide-fade">
      <div class="modal-mask4" v-if="show4">
        <div class="modal-wrapper4">
          <div class="modal-container4">
            <div class="modal-header">
              <h4 style="text-align:right;cursor:pointer;" @click="show4 = false"><i class="fa fa-times-circle"></i></h4>
              <slot name="header">
                 Edit Federation General Member Information
              </slot>
            </div>

            <div class="modal-body">
              <div class="wrappermodel">
              <div class="lefside">
                <span>Male</span>
                 <input type="text" id="recivedamount" v-model="federationgeneralmemberMale"  class="form-control">
                 <span>Female</span>
                  <input type="text" v-model="federationgeneralmemberFemale"   class="form-control">
                  <span >Total</span>
                  <input type="text"   class="form-control" v-model="federationgeneralmemberTotal">
                  <span >PWD Member</span>
                  <input type="text"   class="form-control" v-model="federationgeneralmemberPWD_Member">
                  <span >Indigenous People</span>
                  <input type="text"   class="form-control" v-model="federationgeneralmemberIndigenous_People">
                  <span >Excluded Members</span>
                  <input type="text"   class="form-control" v-model="federationgeneralmemberExecludedmember">
              </div>
            </div>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="updategeneralmemberinformation()">
                  Update General Member Information Information
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
     </transition>  

    <transition name="slide-fade">
      <div class="modal-mask5" v-if="show5">
        <div class="modal-wrapper5">
          <div class="modal-container5">
            <div class="modal-header">
              <h4 style="text-align:right;cursor:pointer;" @click="show5 = false"><i class="fa fa-times-circle"></i></h4>
              <slot name="header">
                 Edit General Committee Member Information
              </slot>
            </div>
            <div class="modal-body">
              <div class="wrappermodel">
              <div class="lefside">
                <span>Male </span>
                 <input type="text" id="recivedamount" v-model="generalcommitteemembermale"  class="form-control">
                 <span>Female </span>
                  <input type="text" v-model="generalcommitteememberfemale"   class="form-control">
                  <span >Total</span>
                  <input type="text"   class="form-control" v-model="generalcommitteemembertotal">
              </div>
            </div>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="updategeneralcommitteememeberinformation()">
                  Update General Committee Member Information
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
     </transition> 

     <transition name="slide-fade">
      <div class="modal-mask6" v-if="show6">
        <div class="modal-wrapper6">
          <div class="modal-container6">
            <div class="modal-header">
              <h4 style="text-align:right;cursor:pointer;" @click="show6 = false"><i class="fa fa-times-circle"></i></h4>
              <slot name="header">
                 Edit Executive Committee Member Information
              </slot>
            </div>
            <div class="modal-body">
              <div class="wrappermodel">
              <div class="lefside">
                <span>Male </span>
                 <input type="text" id="recivedamount" v-model="executivecommitteememberMale"  class="form-control">
                 <span>Female </span>
                  <input type="text" v-model="executivecommitteememberFemale"   class="form-control">
                  <span >Total</span>
                  <input type="text"   class="form-control" v-model="executivecommitteememberTotal">
              </div>
            </div>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="updateexecutivememberinformation()">
                  Update Executive Committee Member Information
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
     </transition>  

</template>
<script>
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
export default{
 	props:['federationid','edit'],
    components: {
    Loading
    },
	data(){
			return{
				  searchproduct:'',
			    federationlist:[],
			    federationok:false,
			    suggestion:false,
			    federation:'',
				  registrationinformation:[],
				  federationgroupinformation:[],
				  federationgeneralmember:[],
          generalcommitteemember:[],
          executivecommitteemember:[],
          federationname:'',
          fedrid:0,
          isLoading: false,
          fullPage: true,
          Date_of_application_deposited:'',
          If_Dont_is_applied_for_registration_YesNo:'',
          If_applied_name_of_the_organization_DSSDYD_DCDWA:'',
          Present_status:'',
          RegistrationNumber:'',
          RegistrationReceivedfrom:'',
          registrationid:0,
          show2:false,
          show3:false,
          show4:false,
          show5:false,
          show6:false,
          groupinformationMale_Group:0,
          groupinformationFemale_Group:0,
          groupinformationTotal:0,
          groupinformationid:0,
          federationgeneralmemberid:0,
          federationgeneralmemberMale:0,
          federationgeneralmemberFemale:0,
          federationgeneralmemberTotal:0,
          federationgeneralmemberExecludedmember:0,
          federationgeneralmemberIndigenous_People:0,
          federationgeneralmemberPWD_Member:0,
          generalcommitteemembermale:0,
          generalcommitteememberfemale:0,
          generalcommitteemembertotal:0,
          executivecommitteememberFemale:0,
          executivecommitteememberMale:0,
          executivecommitteememberTotal:0,
          generalcommitteememberid:0,
          executivecommitteememberid:0,
          

			}
	 },
	 mounted(){
	 	this.getfederationdetails();
	 	document.addEventListener('click', this.pageClick);
	 },
	 beforeUnmount() {
      document.removeEventListener('click', this.pageClick);
     },
     computed:{
     url(){
      return this.$store.state.url;
    }
   
    },




	 methods:{
    registrationifnormation(registrationinformation){
          this.show2=true;
          this.Date_of_application_deposited=registrationinformation.Date_of_application_deposited;
          this.If_Dont_is_applied_for_registration_YesNo=registrationinformation.If_Dont_is_applied_for_registration_YesNo;
          this.If_applied_name_of_the_organization_DSSDYD_DCDWA=registrationinformation.If_applied_name_of_the_organization_DSSDYD_DCDWA;
          this.Present_status=registrationinformation.Present_status;
          this.RegistrationNumber=registrationinformation.RegistrationNumber;
          this.RegistrationReceivedfrom=registrationinformation.RegistrationReceivedfrom;
          this.registrationid=registrationinformation.id;


      },



    updateregistration(){
      this.show2=false;
      this.isLoading=true;
      axios.post(this.url+'updateregistrationinfromation',{
        Date_of_application_deposited:this.Date_of_application_deposited,
        If_Dont_is_applied_for_registration_YesNo:this.If_Dont_is_applied_for_registration_YesNo,
        If_applied_name_of_the_organization_DSSDYD_DCDWA:this.If_applied_name_of_the_organization_DSSDYD_DCDWA,
        Present_status:this.Present_status,
        RegistrationNumber:this.RegistrationNumber,
        RegistrationReceivedfrom:this.RegistrationReceivedfrom,
        id:this.registrationid,
      }).then(response=>{
        this.isLoading=false;
        toast.success("Federation registration has updated successfully", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });

      });
      this.getfederationdetails();

      },


    federationgroupinformationupdate(federationgroupinformation){

         this.show3=true;
         this.groupinformationMale_Group=federationgroupinformation.Male_Group;
         this.groupinformationFemale_Group=federationgroupinformation.Female_Group;
         this.groupinformationTotal=federationgroupinformation.Total;
         this.groupinformationid=federationgroupinformation.id;
         console.log(federationgroupinformation);

    },
    updategroupinformation(){

      this.show3=false;
      this.isLoading=true;
      axios.post(this.url+'updategroupinfromation',{
        groupinformationMale_Group:this.groupinformationMale_Group,
        groupinformationFemale_Group:this.groupinformationFemale_Group,
        groupinformationTotal:this.groupinformationTotal,
        groupinformationid:this.groupinformationid
      }).then(response=>{
        this.isLoading=false;
        toast.success("Federation groupinformation has updated successfully", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });

      });
      this.getfederationdetails();

    },

    federationgeneralmemberupdate(federationgeneralmember){
      this.show4=true;
      this.federationgeneralmemberMale=federationgeneralmember.Male;
      this.federationgeneralmemberFemale=federationgeneralmember.Female;
      this.federationgeneralmemberTotal=federationgeneralmember.Total;
      this.federationgeneralmemberExecludedmember=federationgeneralmember.Excluded_Members;
      this.federationgeneralmemberIndigenous_People=federationgeneralmember.Indigenous_People;
      this.federationgeneralmemberPWD_Member=federationgeneralmember.PWD_Member;
      this.federationgeneralmemberid=federationgeneralmember.id;


    },
    
    updategeneralmemberinformation(){
      this.show4=false;
      this.isLoading=true;
      axios.post(this.url+'updategeneralmemberinfromation',{
             federationgeneralmemberMale:this.federationgeneralmemberMale,
             federationgeneralmemberFemale:this.federationgeneralmemberFemale,
             federationgeneralmemberTotal:this.federationgeneralmemberTotal,
             federationgeneralmemberExecludedmember:this.federationgeneralmemberExecludedmember,
             federationgeneralmemberIndigenous_People:this.federationgeneralmemberIndigenous_People,
             federationgeneralmemberPWD_Member:this.federationgeneralmemberPWD_Member,
             federationgeneralmemberid:this.federationgeneralmemberid
      }).then(response=>{
        this.isLoading=false;
        toast.success("Federation general memeber information has updated successfully", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });

      });
      this.getfederationdetails();

    },
    generalcommitteememberupdate(generalcommitteemember){
      this.show5=true;
      this.generalcommitteemembermale=generalcommitteemember.Male;
      this.generalcommitteememberfemale=generalcommitteemember.Female;
      this.generalcommitteemembertotal=generalcommitteemember.Total;
      this.generalcommitteememberid=generalcommitteemember.id;

    },
    updategeneralcommitteememeberinformation(){
      this.show5=false;
      this.isLoading=true;
      axios.post(this.url+'updategeneralcommitteememeberinformation',{
             generalcommitteemembermale:this.generalcommitteemembermale,
             generalcommitteememberfemale:this.generalcommitteememberfemale,
             generalcommitteemembertotal:this.generalcommitteemembertotal,
             generalcommitteememberid:this.generalcommitteememberid
      }).then(response=>{
        this.isLoading=false;
        toast.success("Federation general committee memeber information has updated successfully", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });

      });
      this.getfederationdetails();
    },
    executivecommitteememberupdate(executivecommitteemember){
      this.show6=true;
      this.executivecommitteememberFemale=executivecommitteemember.Female;
      this.executivecommitteememberMale=executivecommitteemember.Male;
      this.executivecommitteememberTotal=executivecommitteemember.Total;
      this.executivecommitteememberid=executivecommitteemember.id;


    },
    updateexecutivememberinformation(){
       this.show6=false;
       this.isLoading=true;
       axios.post(this.url+'updateexecutivememberinformation',{
             executivecommitteememberFemale:this.executivecommitteememberFemale,
             executivecommitteememberMale:this.executivecommitteememberMale,
             executivecommitteememberTotal:this.executivecommitteememberTotal,
             executivecommitteememberid:this.executivecommitteememberid
      }).then(response=>{
        this.isLoading=false;
        toast.success("Executive memeber information has updated successfully", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });

      });
      this.getfederationdetails();

    },
	  searchfederation(){
      this.isLoading = true;
      if(this.federation==''){
        toast.warning("Please insert a federation name", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });
        this.isLoading = false;
      }else{
        axios.post(this.url+'searchfederationdetails',{
          federationid:this.fedrid,
        }).then(response=>{

        

           setTimeout(() => {
           this.isLoading = false;
           this.registrationinformation=response.data.registrationinformation;
           this.federationgroupinformation=response.data.federationgroupinformation;
           this.federationgeneralmember=response.data.federationgeneralmember;
           this.generalcommitteemember=response.data.generalcommitteemember;
           this.executivecommitteemember =response.data.executivecommitteemember;
           this.federationname=response.data.federationname;
           this.federation='';


           },1000)


        })

      } 
      },
	  pageClick(event){
      if (
           event.target !== this.$refs.inputField &&
           event.target !== this.$refs.suggestionsList
           ) {
            this.federationok = false;
            this.suggestion=false;

       }
     },
     searchInput(event){
      var federationname=event.target.value;
      if(federationname==''){
      this.federationlist=[];
      }else{
        axios.get(this.url+'getfederationlist/'+federationname).then(response=>{
                this.federationlist=response.data;
         console.log(this.federationlist);
        })
        this.federationok=true;

      }

    },
	selectfederation(federation){

	      this.federation=federation.FederationName;
	      this.fedrid=federation.id;
	      console.log(this.fedrid);

	   },
    getfederationdetails(){
           axios.get('/getfederationdetails/'+this.federationid).then(response=>{
                this.registrationinformation=response.data.registrationinformation;
                this.federationgroupinformation=response.data.federationgroupinformation;
                this.federationgeneralmember=response.data.federationgeneralmember;
                this.generalcommitteemember=response.data.generalcommitteemember;
                this.executivecommitteemember =response.data.executivecommitteemember;
                this.federationname=response.data.federationname;
           })
       }

	 },
   watch:{

       show2(newVal) {
         this.$nextTick(() => {
          if (newVal) {
          document.querySelector('.modal-container2').style.transform = 'translateY(0)';
           } else {
          document.querySelector('.modal-container2').style.transform = 'translateY(-100%)';
          }
         });
        },
        show3(newVal) {
         this.$nextTick(() => {
          if (newVal) {
          document.querySelector('.modal-container3').style.transform = 'translateY(0)';
           } else {
          document.querySelector('.modal-container3').style.transform = 'translateY(-100%)';
          }
         });
        },
        show4(newVal) {
         this.$nextTick(() => {
          if (newVal) {
          document.querySelector('.modal-container4').style.transform = 'translateY(0)';
           } else {
          document.querySelector('.modal-container4').style.transform = 'translateY(-100%)';
          }
         });
        },
        show5(newVal) {
         this.$nextTick(() => {
          if (newVal) {
          document.querySelector('.modal-container5').style.transform = 'translateY(0)';
           } else {
          document.querySelector('.modal-container5').style.transform = 'translateY(-100%)';
          }
         });
        },
        show6(newVal) {
         this.$nextTick(() => {
          if (newVal) {
          document.querySelector('.modal-container6').style.transform = 'translateY(0)';
           } else {
          document.querySelector('.modal-container6').style.transform = 'translateY(-100%)';
          }
         });
        }

    }

 }
</script>
<style scoped>
 .productlist
  {
    position: absolute;
    background: #333;
    color: white;
    width: 100%;
    z-index: 999999;
  }
  .productlist ul{
    list-style: none;
    background: rgb(237, 28, 36);
  }
  .productlist ul li{
    border-bottom: 1px solid white;
    padding:5px;
    cursor: pointer;
  }

  .pre-loader {
  padding: 10px;
  background-color: #f1f1f1;
  /* Add more styles as needed */
  }
  </style>

  <style scoped>
.vmodal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal-content {
  width:50%;
  background: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
}

.close {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 20px;
  cursor: pointer;
}

.button {
  margin-top: 10px;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.left {
  flex: 1;
}

.right {
  flex: 1;
  text-align: right;
}

.modal-enter-active, .modal-leave-active {
  transition: transform .5s ease-in, opacity .5s ease-out;
  transform: translateY(-50%);
  opacity: 1;
}
.modal-enter, .modal-leave-to /* .modal-leave-active in <2.1.8 */ {
  transform: translateY(-50%);
  opacity: 0 opacity .5s ease-out;
}

</style>
<style>
  .modal-mask2,.modal-mask3,.modal-mask4,.modal-mask5,.modal-mask6{
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
  }
  .modal-wrapper2,.modal-wrapper3,.modal-wrapper4,.modal-wrapper5,.modal-wrapper6{
    display: table-cell;
    vertical-align: middle;
  } 
  .modal-container2{
  width: 80%;
  margin: 0px auto;
  padding: 20px 30px;
  background: #3a3f51;
  color: white;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  transform: translateY(-100%);
  transition: transform .3s ease-out;
}
.modal-container3,.modal-container4,.modal-container5,.modal-container6{
  width: 45%;
  margin: 0px auto;
  padding: 20px 30px;
  background: #3a3f51;
  color: white;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  transform: translateY(-100%);
  transition: transform .3s ease-out;
}
.modal-header {
    padding: 5px!important;
    border-bottom: 1px solid #e5e5e5;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translate3d(0, -100%, 0);
  opacity: 0;
}
.wrappermodel{
  display: flex;

}
.lefside{
  width:48%;
  float:left;
  padding-right:10px;
}
.modal-container3 .lefside,.modal-container4 .lefside,.modal-container5 .lefside,.modal-container6 .lefside{
  width:100%;
  float:left;
  padding-right:10px;
}
.rightside{
   width:48%;
  float:left;
}
.modal-default-button{
  background: #007bff;
  border: 1px solid #007bff;
  color: white;
}
</style>